import { ApplicationState } from '../redux/ApplicationState'
import Router from '../router'
import { ContextRoute } from './context'
import store from './store'

class Navigator {
    public current: ContextRoute
    public router: Router

    constructor(currentRoute: ContextRoute, router?: Router) {
        this.current = currentRoute
        this.router = router || (store.getState() as ApplicationState).tidewaysContext.router
    }

    public push = (parameters: object, route?: string): void => {
        route = route || this.currentRoute()
        this.router.push(route, this.mergeParameters(parameters))
    }

    public currentRoute = (): string => this.current.route

    public mergeParameters = (parameters: object): object => ({ ...this.current.parameters, ...parameters })

    public replace = (parameters: object, route?: string): void => {
        route = route || this.currentRoute()
        this.router.replace(route, this.mergeParameters(parameters))
    }

    // @DEPRECATED: This method is just for migration. Should be removed as
    // soon as there is no more usage.
    public path = (route: string, parameters: object): string => this.router.path(route, parameters)

    // @DEPRECATED: This method is just for migration. Should be removed as
    // soon as there is no more usage.
    public goTo = (parameters: object): void => {
        this.replace(parameters)
    }
}

export default Navigator
